import React from 'react';
import { Field } from 'formik';
import DatePicker from 'react-datepicker';
import { Label } from 'semantic-ui-react';

const FormikDatePicker = ({ name, label, CustomInput }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <Label className='form-label' style={{ height: "38px" }}>{label}</Label>
    <Field name={name}>
      {({
        field, // { name, value, onChange, onBlur }
        form: { setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
      }) => (
        <div style={{ zIndex: "1000" }}>
          <DatePicker
            selected={field.value}
            onChange={(date) => setFieldValue(name, date)}
            customInput={<CustomInput />}
          />
        </div>
      )}
    </Field>
  </div>
);

export default FormikDatePicker;
